import React, { useEffect, useState } from 'react';
import { ArrowUpIcon } from 'lucide-react';
export const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };
  // Set the top of the page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);
  return <button className={`fixed bottom-8 right-8 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 z-50 ${isVisible ? 'opacity-100 visible' : 'opacity-0 invisible'}`} onClick={scrollToTop} aria-label="Back to top" data-id="element-74">
      <ArrowUpIcon className="h-5 w-5" data-id="element-75" />
    </button>;
};